// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberSharedEmailAddressUpsearchModel {
    static getAttributeTypeMap() {
        return PrescriberSharedEmailAddressUpsearchModel.attributeTypeMap;
    }
}
PrescriberSharedEmailAddressUpsearchModel.discriminator = undefined;
PrescriberSharedEmailAddressUpsearchModel.attributeTypeMap = [
    {
        "name": "emailAddressId",
        "baseName": "emailAddressId",
        "type": "number"
    },
    {
        "name": "emailAddressType",
        "baseName": "emailAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    }
];
//# sourceMappingURL=prescriberSharedEmailAddressUpsearchModel.js.map